<template lang="pug">
  .comment__sending( v-if="!isSendComment")
    .comment-input
      Input.comment-input-value( v-model="text" @keyup.enter="sendData" inputClass="comment-input-value__admin" :error="errorData" placeholder="Напиши комментарий к заданию" )
      .comment-actions
        UploadFiles(
            @getFiles="getFiles"
            buttonClass="comment-btn-prim"
            :fileExt="fileExt"
            :fileMime="fileMime"
            :multiple="true"
            :isIcon="true"
            :hugeFiles="true"
            buttonText="Прикрепить файлы"
        )
        Button.comment-btn( @click="sendData" :isLoading="uploadingFiles")
          | Отправить комментарий
    .comment-files
      File(
        v-for="file in contentLocal.files" :key="file.id"
        :file="file"
        icon="image"
        @deleteFile="addFileToDelete(file)"
      )
  p.ajax__line.ajax__line-card-text(v-else)

</template>
<script>
import _ from 'lodash';
import File from '@/components/File/File';

export default {
  components: {
    File
  },
  props: ['task'],
  data() {
    return {
      text: '',
      contentLocal: {
        files: []
      },
      isSendComment: false,
      errorData: '',
      uploadingFiles: false,
      filesToDelete: [],
      fileExt: ['.odt', '.docx'],
      fileMime: [
        'image/*',
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'text/plain',
        'text/csv'
      ]
    };
  },
  methods: {
    async getFiles({ formData }) {
      this.uploadingFiles = true;
      const files = await this.$store.dispatch('ajax/uploadFile', { formData });
      this.uploadingFiles = false;
      if (files) {
        files.forEach(f => {
          this.contentLocal.files.push(f);
        });
      }
    },
    async addFileToDelete(file) {
      this.filesToDelete.push(file);
      const fileIdx = this.contentLocal.files.findIndex(f => f.id === file.id);
      if (fileIdx !== -1) {
        this.contentLocal.files.splice(fileIdx, 1);
        this.contentLocal.files = [...this.contentLocal.files];
      }
    },
    async sendData() {
      if (this.contentLocal.files.length === 0 && !this.text) {
        this.errorData = 'Нельзя отправить пустой комментарий';
        return;
      }
      this.errorData = '';
      const newObjectSending = _.cloneDeep(this.task);
      const objComment = {
        commentatorFiles: this.contentLocal.files,
        text: this.text
      };
      const oldAnswer = newObjectSending.answer
        ? { ...newObjectSending.answer }
        : {};
      newObjectSending.answer = { ...oldAnswer, comments: objComment };
      this.isSendComment = true;
      const res = await this.$store.dispatch(
        'answersValidatingFeed/sendComment',
        newObjectSending
      );
      this.isSendComment = false;

      if (res) {
        this.text = '';
        this.contentLocal.files = [];
        this.filesToDelete = [];
      }
    }
  }
};
</script>
